import React from 'react'

import './Common_Back_Header.css'
import { useNavigate } from 'react-router-dom'

const Common_Back_Header = ({ backNavigation, showOrderStatus, orderStatusClick }) => {

  const navigate = useNavigate()

  return (
    <section className='Common_Back_Header'>
      <p className='back_text' onClick={() => {
        if (typeof backNavigation === "number") {
          navigate(backNavigation);
        } else {
          navigate(backNavigation || "/home");
        }
      }}>Back</p>

      {showOrderStatus && (
        <p className='right_text' onClick={orderStatusClick} >
          Order Status
        </p>
      )}


    </section>
  )
}

export default Common_Back_Header
